import React, { useEffect, useState } from 'react';
import { Button, Table, Modal, Input, message, Popconfirm, Space, Card } from 'antd';
import { DeleteFilled } from '@ant-design/icons';
import api from '@/services/api';

const ManagementAnnouncemenets = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newModalOpen, setNewModalOpen] = useState(false);
  const [newTitle, setNewTitle] = useState('');
  const [saving, setSaving] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await api()({
        url: '/webshop/management/announcement',
        method: 'GET'
      });
      setData(response.data.data || []);
    } catch (error) {
      console.error('Error fetching announcement:', error);
      message.error('Failed to load announcements');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api()({
        url: `/webshop/management/announcement/${id}`,
        method: 'DELETE'
      });
      message.success('Deleted');
      fetchData();
    } catch (error) {
      console.error('Delete error:', error);
      message.error('Delete failed');
    }
  };

  const handleCreate = async () => {
    if (!newTitle?.trim()) return message.warning('Title cannot be empty');

    setSaving(true);
    try {
      await api()({
        url: '/webshop/management/announcement',
        method: 'POST',
        data: { title: newTitle }
      });
      message.success('Announcement created');
      setNewModalOpen(false);
      setNewTitle('');
      fetchData();
    } catch (error) {
      console.error('Create error:', error);
      message.error('Failed to create');
    } finally {
      setSaving(false);
    }
  };

  const columns = [
    {
      title: 'Text',
      dataIndex: 'Title',
      key: 'Title'
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Popconfirm
          title="Are you sure?"
          onConfirm={() => handleDelete(record.Id)}
        >
          <Button danger icon={<DeleteFilled />} />
        </Popconfirm>
      ),
      align: 'right'
    }
  ];


  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div style={{ background: '#fff', padding: 24, borderRadius: 12 }}>
      <Space style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <h3>Announcemenets</h3>
        <Button type="primary" onClick={() => setNewModalOpen(true)}>New</Button>
      </Space>

      <Table
        columns={columns}
        dataSource={data}
        rowKey="Id"
        pagination={{ pageSize: 5 }}
        loading={loading}
      />

      <Modal
        title="New Announcement"
        open={newModalOpen}
        onCancel={() => setNewModalOpen(false)}
        onOk={handleCreate}
        confirmLoading={saving}
        okText="Save"
      >
        <Input.TextArea
          rows={4}
          placeholder="Enter announcement text"
          value={newTitle}
          onChange={e => setNewTitle(e.target.value)}
        />
      </Modal>
    </div>
  );
};

export default ManagementAnnouncemenets;
